import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CreateExpedition from '@app/pages/expedition/create/CreateExpedition.tsx';
import { EntityTypeEnum, PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { useParams, useSearchParams } from 'react-router-dom';

interface ComponentProps {
}

const CreateExpeditionPage: React.FC<ComponentProps> = () => {
  const { entityId } = useParams();
  const [searchParams] = useSearchParams();
  const { tr } = useTranslationLgs();

  const queryParamsString = searchParams.get('queryParams');
  const parsedParams = new URLSearchParams(decodeURIComponent(queryParamsString || ''));

  const entityTypeParam = searchParams.get('entityType');
  const entityType = entityTypeParam && Object.values(EntityTypeEnum).includes(entityTypeParam as EntityTypeEnum)
    ? (entityTypeParam as EntityTypeEnum)
    : undefined;

  const entity = entityId && entityType ? { id: entityId, type: entityType } : null;

  const prefillOptions = {
    routeAndParameters: parsedParams.get('routeAndParameters') === 'true',
    cargoAndOrders: parsedParams.get('cargoAndOrders') === 'true',
    documents: parsedParams.get('documents') === 'true',
    labels: parsedParams.get('labels') === 'true',
    internalInfo: parsedParams.get('internalInfo') === 'true',
    carrierSelection: parsedParams.get('carrierSelection') === 'true',
    carrierNote: parsedParams.get('carrierNote') === 'true',
    linkToSN: parsedParams.get('linkToSN') === 'true',
    copySNAttachments: parsedParams.get('copySNAttachments') === 'true',
    markAsPrivate: parsedParams.get('markAsPrivate') === 'true',
  };

  return (
    <>
      <ResponsiveLayout title={tr('create.vytvoreniExpedice', 'Vytvoření expedice')}
                        oneOfPermission={[
                          PermissionTypesEnum.PERMISSION_EXPEDITION_CREATE,
                        ]}
      >
        <CreateExpedition
          entity={entity}
          prefillOptions={prefillOptions} />
      </ResponsiveLayout>
    </>);

};

export default withAuthenticationRequired(CreateExpeditionPage);